import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';

const selectSelf = (s: RootState) => s.membership;

export const hasMembershipSelector = createSelector(
  selectSelf,
  (s) => s.hasMembership,
);

export const isLoggedInSelector = createSelector(
  selectSelf,
  (s) => s.isLoggedIn,
);

export const membershipErrorSelector = createSelector(
  selectSelf,
  (s) => s.membershipError,
);
